<div class="grid-container margin-top">
  <form [formGroup]="form">
    <div class="grid-x">
      <div class="cell small-6 medium-4 large-4">
        <label for="api">
          Provide the API # for the well to be plugged:<span class="bold" [ngClass]="{ 'red' : form?.get('api')?.invalid }">*</span>
        </label>
      </div>
      <div class="cell small-6 medium-4 large-4">
        <input type="number" formControlName="api" />
      </div>
      <div class="cell small-12 medium-4 large-4 padding-left">
        <button class="button" (click)="searchAPI()" [disabled]="form?.get('api')?.invalid || searchActive?.value == true">Search for API</button>
      </div>
      <div class="cell small-12 medium-12 large-12">
        <text-loader [run]="searchActive?.value == true" [text]="'Searching'" [interval]="1000" [tickType]="'.'"></text-loader>
      </div>
    </div>
    @if (programStatus?.well != null) {
      <section aria-label="Landowner Information">
        <div class="grid-x">
          <div class="cell large-12 medium-12 small-12 bold">
            <div class="section-header" [ngClass]="{ 'active' : showLandownerSection == true }" (click)="toggleSection('landowner')">
              <span class="margin-right">Landowner Information</span>
              <button class="icon-button">
                @if (showLandownerSection == false) {
                  <svg-icon icon="icon-caret-right"></svg-icon>
                }
                @if (showLandownerSection == true) {
                  <svg-icon icon="icon-caret-down"></svg-icon>
                }
              </button>
            </div>
          </div>
        </div>
        <div class="grid-x margin-top" [ngClass]="{ 'hideSection': showLandownerSection == false }">
          <div class="cell large-2 medium-2 small-4 bold text-align-right padding-right">
            <label for="landownerName">Landowner Name:<span class="bold" [ngClass]="{ 'red' : form?.get('landownerName')?.invalid }">*</span></label>
          </div>
          <div class="cell large-4 medium-4 small-6">
            <input type="text" formControlName="landownerName" />
          </div>
          <div class="cell large-6 medium-6 small-12">&nbsp;</div>
          <div class="cell large-2 medium-2 small-4 bold text-align-right padding-right">
            <label for="landownerPhone">Landowner Phone:</label>
          </div>
          <div class="cell large-4 medium-4 small-6">
            <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" formControlName="landownerPhone" />
          </div>
          <div class="cell large-2 medium-2 small-4 bold text-align-right padding-right">
            <label for="landownerEmail">Email:</label>
          </div>
          <div class="cell large-4 medium-4 small-6">
            <input type="text" formControlName="landownerEmail" />
          </div>
        </div>
        <div class="grid-x" [formGroup]="landownerAddressForm" [ngClass]="{ 'hideSection': showLandownerSection == false }">
          <div class="cell large-2 medium-2 small-4 bold text-align-right padding-right">
            <label for="landownerStreet">Street Address:</label>
          </div>
          <div class="cell large-4 medium-3 small-6">
            <input type="text" formControlName="street" />
          </div>
          <div class="cell large-2 medium-3 small-4 bold text-align-right padding-right">
            <label for="landownerSuite">Suite:</label>
          </div>
          <div class="cell large-4 medium-3 small-6">
            <input type="text" formControlName="suite" />
          </div>
          <div class="cell large-2 medium-2 small-4 bold  text-align-right padding-right">
            <label for="landOwnerPOBox">P.O. Box:</label>
          </div>
          <div class="cell large-4 medium-4 small-6">
            <input type="text" formControlName="poBox" />
          </div>
          <div class="cell large-6 medium-6 small-12">&nbsp;</div>
          <div class="cell large-2 medium-2 small-3  text-align-right padding-right">
            <label for="landownerCity">City:</label>
          </div>
          <div class="cell large-4 medium-4 small-3">
            <input type="text" formControlName="city" />
          </div>
          <div class="cell large-2 medium-2 small-3  text-align-right padding-right">
            <label for="landOwnerState">State:</label>
          </div>
          <div class="cell large-1 medium-1 small-3">
            <select formControlName="state">
              @for (state of states; track state) {
                <option [ngValue]="state.Code">{{state.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-2 medium-2 small-6  text-align-right padding-right">
            <label for="landOwnerZip">Zip Code:</label>
          </div>
          <div class="cell large-1 medium-1 small-6">
            <input type="text" formControlName="zip" />
          </div>
        </div>
      </section>
      <section aria-label="Well Location">
        <div class="grid-x">
          <div class="cell large-12 medium-12 small-12 bold">
            <div class="section-header" [ngClass]="{ 'active' : showWellLocationSection == true }" (click)="toggleSection('wellLocation')">
              <span class="margin-right">Well Location</span>
              <button class="icon-button">
                @if (showWellLocationSection == false) {
                  <svg-icon icon="icon-caret-right"></svg-icon>
                }
                @if (showWellLocationSection == true) {
                  <svg-icon icon="icon-caret-down"></svg-icon>
                }
              </button>
            </div>
          </div>
        </div>
        <div class="grid-x margin-top" [formGroup]="wellDataForm" [ngClass]="{ 'hideSection': showWellLocationSection == false }">
          <div class="cell small-6 medium-2 large-2 bold text-align-right padding-right">
            <label>GPS NAD83 Latitude:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="number" formControlName="latitude" />
          </div>
          <div class="cell small-6 medium-4 large-4 bold text-align-right padding-right">
            <label>GPS NAD83 Longitude:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="number" formControlName="longitude" />
          </div>
          <div class="cell small-6 medium-2 large-2 bold text-align-right padding-right">
            <label>County:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <select id="county" formControlName="county" [ngStyle]="{ 'display': countiesLoaded ? 'inherit' : 'none' }">
              @for (c of countyObservable | async; track c) {
                <option [ngValue]="c">{{c}}</option>
              }
            </select>
            <text-loader [text]="'Loading Counties'" [tickType]="'.'" [interval]="2000" [runObservable]="countyLoader" [cycleLimit]="5"></text-loader>
          </div>
          <div class="cell small-6 medium-4 large-4 bold text-align-right padding-right">
            <label>Civil Township:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <select id="township" formControlName="township" [ngStyle]="{ 'display': townshipsLoaded ? 'inherit' : 'none' }">
              @for (t of townshipObservable | async; track t) {
                <option [ngValue]="t">{{t}}</option>
              }
            </select>
            <text-loader [text]="'Loading Townships'" [tickType]="'.'" [interval]="2000" [runObservable]="townshipLoader" [cycleLimit]="5"></text-loader>
          </div>
          <div class="cell small-6 medium-2 large-2 bold text-align-right padding-right">
            <label>Section:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="section" />
          </div>
          <div class="cell small-6 medium-4 large-4 bold text-align-right padding-right">
            <label>Lot:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="lot" />
          </div>
          <div class="cell small-6 medium-2 large-2 bold text-align-right padding-right">
            <label>Tract:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="tract" />
          </div>
          <div class="cell small-6 medium-4 large-4 bold text-align-right padding-right">
            <label>Urbanized Area (as defined by ORC 1509.01(Y)):</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <select formControlName="urbanized">
              <option value="" selected>--</option>
              <option value="Y">Yes</option>
              <option value="N">No</option>
            </select>
          </div>
        </div>
      </section>
      <section aria-label="Well Information">
        <div class="grid-x">
          <div class="cell large-12 medium-12 small-12 bold">
            <div class="section-header" [ngClass]="{ 'active' : showWellInformationSection == true }" (click)="toggleSection('wellInformation')">
              <span class="margin-right">Well Information</span>
              <button class="icon-button">
                @if (showWellInformationSection == false) {
                  <svg-icon icon="icon-caret-right"></svg-icon>
                }
                @if (showWellInformationSection == true) {
                  <svg-icon icon="icon-caret-down"></svg-icon>
                }
              </button>
            </div>
          </div>
        </div>
        <div class="grid-x margin-top" [formGroup]="wellDataForm" [ngClass]="{ 'hideSection': showWellInformationSection == false }">
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Well Name:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="name" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Well Number:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="number" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>API #:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="api" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Last Owner:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="lastOwner" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Date of Last Production:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <common-date-picker (dateUpdated)="lastProductionDateChanged($event)"></common-date-picker>
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Total Depth to be Plugged (feet):</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" mask="separator" thousandSeparator="," formControlName="depthPlugged" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Amount of Last Oil (bbls):</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" mask="separator" thousandSeparator="," formControlName="amountLastOil" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Amount of Last Gas (mcf):</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" mask="separator" thousandSeparator="," formControlName="amountLastGas" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Amount of Water (gallons):</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" mask="separator" thousandSeparator="," formControlName="amountWater" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Water Source:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="waterSource" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Watershed:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            @for (shed of watersheds; track shed) {
              <label>
                <input type="radio" [id]="shed.Code" [value]="shed.Code" formControlName="watershed" />{{shed.Definition}}
              </label>
            }
          </div>
          <div class="cell small-12 medium-12 large-12">&nbsp;</div>
        </div>
      </section>
      <section aria-label="Orphan Well Inspectors">
        <div class="grid-x">
          <div class="cell large-12 medium-12 small-12 bold">
            <div class="section-header" [ngClass]="{ 'active': showInspectorSection == true }" (click)="toggleSection('inspector')">
              <span class="margin-right">Orphan Well Inspector Information</span>
              <button class="icon-button">
                @if (showInspectorSection == false) {
                  <svg-icon icon="icon-caret-right"></svg-icon>
                }
                @if (showInspectorSection == true) {
                  <svg-icon icon="icon-caret-down"></svg-icon>
                }
              </button>
            </div>
          </div>
        </div>
        <div class="grid-x margin-top" [ngClass]="{ 'hideSection': showInspectorSection == false }" [formGroup]="inspectorForm">
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label for="inspectorName">
              Inspector Name: <span class="bold" [ngClass]="{ 'red' : inspectorForm?.get('inspectorName')?.invalid }">*</span>
            </label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="inspectorName" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label for="inspectorPhone">
              Inspector Phone: <span class="bold" [ngClass]="{ 'red' : inspectorForm?.get('inspectorPhone')?.invalid }">*</span>
            </label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" formControlName="inspectorPhone" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label for="backupInspectorName">
              Backup Inspector Name: <span class="bold" [ngClass]="{ 'red' : inspectorForm?.get('backupInspectorName')?.invalid }">*</span>
            </label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="backupInspectorName" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label for="backupInspectorPhone">
              Backup Inspector Phone: <span class="bold" [ngClass]="{ 'red' : inspectorForm?.get('backupInspectorPhone')?.invalid }">*</span>
            </label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" formControlName="backupInspectorPhone" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label for="supervisorName">
              Supervisor Name: <span class="bold" [ngClass]="{ 'red' : inspectorForm?.get('supervisorName')?.invalid }">*</span>
            </label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="supervisorName" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label for="supervisorPhone">
              Supervisor Phone: <span class="bold" [ngClass]="{ 'red' : inspectorForm?.get('supervisorPhone')?.invalid }">*</span>
            </label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" formControlName="supervisorPhone" />
          </div>
        </div>
      </section>
      <section aria-label="Emergency Contact Numbers">
        <div class="grid-x">
          <div class="cell large-12 medium-12 small-12 bold">
            <div class="section-header" [ngClass]="{ 'active' : showEmergencySection == true }" (click)="toggleSection('emergency')">
              <span class="margin-right">Emergency Contact Information</span>
              <button class="icon-button">
                @if (showEmergencySection == false) {
                  <svg-icon icon="icon-caret-right"></svg-icon>
                }
                @if (showEmergencySection == true) {
                  <svg-icon icon="icon-caret-down"></svg-icon>
                }
              </button>
            </div>
          </div>
        </div>
        <div class="grid-x margin-top" [ngClass]="{ 'hideSection': showEmergencySection == false }" [formGroup]="emergencyDataForm">
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Fire Phone #:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="firePhone" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Fire Extension:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="fireExtension" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Medical Phone #:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="medicalPhone" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Medical Extension:</label>
          </div>
          <div class="cell small-6 medium-3 large-3">
            <input type="text" formControlName="medicalExtension" />
          </div>
          <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
            <label>Means of Ingress and Egress:</label>
          </div>
          <div class="cell small-6 medium-9 large-9">
            <textarea formControlName="ingress"></textarea>
          </div>
        </div>
      </section>
      <section aria-label="Contractor Information">
        <div class="grid-x">
          <div class="cell large-12 medium-12 small-12 bold">
            <div class="section-header" [ngClass]="{ 'active' : showContractorSection == true }" (click)="toggleSection('contractor')">
              <span class="margin-right">Contractor Information</span>
              <button class="icon-button">
                @if (showContractorSection == false) {
                  <svg-icon icon="icon-caret-right"></svg-icon>
                }
                @if (showContractorSection == true) {
                  <svg-icon icon="icon-caret-down"></svg-icon>
                }
              </button>
            </div>
          </div>
        </div>
        <div class="grid-x margin-top" [ngClass]="{ 'hideSection': showContractorSection == false }">
          <div class="cell large-2 medium-2 small-4 bold text-align-right padding-right">
            <label for="contractorName">Contractor Name:<span class="bold" [ngClass]="{ 'red' : form?.get('contractorName')?.invalid }">*</span></label>
          </div>
          <div class="cell large-4 medium-4 small-6">
            <input type="text" formControlName="contractorName" />
          </div>
          <div class="cell large-3 medium-3 small-4 bold text-align-right padding-right">
            <label for="contractorRepresentative">Contractor Representative:<span class="bold" [ngClass]="{ 'red' : form?.get('contractorRepresentative')?.invalid }">*</span></label>
          </div>
          <div class="cell large-3 medium-3 small-6">
            <input type="text" formControlName="contractorRepresentative" />
          </div>
          <div class="cell large-2 medium-2 small-4 bold text-align-right padding-right">
            <label for="contractorEstimate">Contractor Estimate:</label>
          </div>
          <div class="cell large-4 medium-4 small-6">
            <input type="text" mask="separator.2" thousandSeparator="," prefix="$" formControlName="contractorEstimate" />
          </div>
          <div class="cell large-3 medium-3 small-12 text-align-right padding-right">
            Email:
          </div>
          <div class="cell large-3 medium-3 small-6">
            <input type="text" formControlName="contractorEmail" />
          </div>
          <div class="cell large-2 medium-4 small-12 text-align-right padding-right">
            Office Phone:
          </div>
          <div class="cell large-4 medium-4 small-6">
            <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" formControlName="contractorOfficePhone" />
          </div>
          <div class="cell large-3 medium-3 small-12 text-align-right padding-right">
            Cell Phone:
          </div>
          <div class="cell large-3 medium-3 small-6">
            <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" formControlName="contractorCellPhone" />
          </div>
        </div>
        <div class="grid-x" [ngClass]="{ 'hideSection': showContractorSection == false }" [formGroup]="contractorAddressForm">
          <div class="cell large-2 medium-2 small-4 bold text-align-right padding-right">
            <label for="contractorStreet">Street Address:</label>
          </div>
          <div class="cell large-4 medium-3 small-6">
            <input type="text" formControlName="street" />
          </div>
          <div class="cell large-3 medium-3 small-4 bold text-align-right padding-right">
            <label for="contractorSuite">Suite:</label>
          </div>
          <div class="cell large-3 medium-3 small-6">
            <input type="text" formControlName="suite" />
          </div>
          <div class="cell large-2 medium-2 small-4 bold  text-align-right padding-right">
            <label for="contractorPOBox">P.O. Box:</label>
          </div>
          <div class="cell large-4 medium-4 small-6">
            <input type="text" formControlName="poBox" />
          </div>
          <div class="cell large-6 medium-6 small-12">&nbsp;</div>
          <div class="cell large-2 medium-2 small-3  text-align-right padding-right">
            <label for="contractorCity">City:</label>
          </div>
          <div class="cell large-4 medium-4 small-3">
            <input type="text" formControlName="city" />
          </div>
          <div class="cell large-2 medium-2 small-3  text-align-right padding-right">
            <label for="contractorState">State:</label>
          </div>
          <div class="cell large-1 medium-1 small-3">
            <select formControlName="state">
              @for (state of states; track state) {
                <option [ngValue]="state.Code">{{state.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-2 medium-2 small-6  text-align-right padding-right">
            <label for="contractorZip">Zip Code:</label>
          </div>
          <div class="cell large-1 medium-1 small-6">
            <input type="text" formControlName="zip" />
          </div>
        </div>
      </section>
      <section aria-label="Documentation">
        <div class="grid-x">
          <div class="cell large-12 medium-12 small-12 bold">
            <div class="section-header" [ngClass]="{ 'active' : showDocumentationSection == true }" (click)="toggleSection('documentation')">
              <span class="margin-right">Documentation</span>
              <button class="icon-button">
                @if (showDocumentationSection == false) {
                  <svg-icon icon="icon-caret-right"></svg-icon>
                }
                @if (showDocumentationSection == true) {
                  <svg-icon icon="icon-caret-down"></svg-icon>
                }
              </button>
            </div>
          </div>
        </div>
        <div class="grid-x margin-top" [ngClass]="{ 'hideSection' : showDocumentationSection == false}">
          <div class="cell large-12 medium-12 small-12">
            <upload-view-files [uniqueId]="'packet'" [files]="packetFiles" [componentLabel]="'Landowner Pass-through Payment Plugging Application Packet'" [showFileList]="true" [allowDeletion]="true" (fileRemoved)="packetFileRemoved($event)" (newFilesList)="packetFileAdded($event)"></upload-view-files>
          </div>
          <div class="cell large-12 medium-12 small-12">
            <upload-view-files [uniqueId]="'application'" [files]="applicationFiles" [componentLabel]="'Landowner Pass-through Payment Plugging Application'" [showFileList]="true" [allowDeletion]="true" (fileRemoved)="applicationFileRemoved($event)" (newFilesList)="applicationFileAdded($event)"></upload-view-files>
          </div>
          <div class="cell large-12 medium-12 small-12">
            <upload-view-files [uniqueId]="'contractor'" [files]="contractorFiles" [componentLabel]="'Proposed Contract and Scope of Work from Proposed Contractor'" [showFileList]="true" [allowDeletion]="true" (fileRemoved)="contractorFileRemoved($event)" (newFilesList)="contractorFileAdded($event)"></upload-view-files>
          </div>
          <div class="cell large-12 medium-12 small-12">
            <upload-view-files [uniqueId]="'map'" [files]="mapFiles" [componentLabel]="'Map Identifying access to the well'" [showFileList]="true" [allowDeletion]="true" (fileRemoved)="mapFileRemoved($event)" (newFilesList)="mapFileAdded($event)"></upload-view-files>
          </div>
          <div class="cell large-12 medium-12 small-12">
            <upload-view-files [uniqueId]="'affidavit'" [files]="affidavitFiles" [componentLabel]="affidavitString" [showFileList]="true" [allowDeletion]="true" (fileRemoved)="affidavitFileRemoved($event)" (newFilesList)="affidavitFileAdded($event)"></upload-view-files>
          </div>
          <div class="cell large-12 medium-12 small-12">
            <upload-view-files [uniqueId]="'plugPlan'" [files]="plugFiles" [componentLabel]="'Well Plugging Plan (Form 1-PP)'" [showFileList]="true" [allowDeletion]="true" (fileRemoved)="plugFileRemoved($event)" (newFilesList)="plugFileAdded($event)"></upload-view-files>
          </div>
          <div class="cell large-12 medium-12 small-12">
            <upload-view-files [uniqueId]="'restoration'" [files]="restorationFiles" [componentLabel]="'Well Plugging and Restoration Agreement ORC 1509.071(E)(2)'" [showFileList]="true" [allowDeletion]="true" (fileRemoved)="restorationFileRemoved($event)" (newFilesList)="restorationFileAdded($event)"></upload-view-files>
          </div>
        </div>
      </section>
      <section aria-label="Submit">
        <div class="grid-x margin-top">
          <!--<div class="cell small-6 medium-6 large-6 text-align-right padding-right">
          <button class="button" (click)="confirmCancel()">Cancel</button>
        </div>
        <div class="cell small-6 medium-6 large-6 text-align-left padding-left">
          <button class="button" (click)="confirmSubmit()" [disabled]="form?.invalid">Submit Application</button>
        </div>-->
        <div class="cell small-4 medium-4 large-4 text-align-right padding-right">
          <button class="button" (click)="confirmCancel()">Cancel</button>
        </div>
        <div class="cell small-4 medium-4 large-4 text-align-center padding-left padding-right">
          <button class="button" (click)="saveForLater()">Save For Later</button>
        </div>
        <div class="cell small-4 medium-4 large-4 text-align-left padding-left">
          <button class="button" (click)="submitForApproval()" [disabled]="form?.invalid">Submit Application</button>
        </div>
      </div>
    </section>
  }

</form>
</div>
